import {useContext, useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';
import {PicturesContext} from 'util/image/PictureContext';

const ReorderWrapper = ({children}) => {
    const location = useLocation();
    const prevLocationRef = useRef(location.pathname);
    const {reorder} = useContext(PicturesContext);

    // Use a state variable to control rendering of children
    useEffect(() => {
        const performReorder = async () => {
            if (prevLocationRef.current !== location.pathname) {
                if (!location.pathname.startsWith('/image/')) {
                    console.log('Reordering | current: ', location.pathname, ' | prev: ', prevLocationRef.current);
                    prevLocationRef.current = location.pathname;
                    reorder();
                } else {
                    prevLocationRef.current = location.pathname;
                }
            }
        };
        performReorder();
    }, [location.pathname, reorder]);

    return children;
};

export default ReorderWrapper;
